<div class="card" *blockUI="'section-block'">
  <div class="row">
    <div class="col-md-6 col-6">
      <div class="d-flex justify-content-start align-items-center m-1">
        <button class="btn btn-primary" rippleEffect (click)="toggleSidebar($event,'create-project',null)">
          <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
            class="d-none d-sm-inline-block">Proje Ekle</span>
        </button>
      </div>
    </div>
    <div class="col-md-6 col-12 d-flex justify-content-md-end">
      <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">

        <label class="d-flex align-items-center">
          <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="50">50</option>
          </select>
        </label>
        <label class="d-flex align-items-center">
          <input type="search" placeholder="Bul" class="form-control ml-25" (keyup)="filterUpdate($event)"
            (search)="filterUpdate($event)" />
        </label>
      </div>
    </div>
  </div>
  <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
    [scrollbarH]="true" (activate)="onActivate($event)">

    <ngx-datatable-column name="Proje Adı" prop="name" [width]="200"></ngx-datatable-column>
    <ngx-datatable-column name="Sorumlu Kişi" [width]="200">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{row.userName}} {{row.userLastName}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="#" [width]="120" [sortable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="d-flex align-items-center">

          <a (click)="toggleSidebar($event,'create-project',row.id)">
            <i data-feather="edit" class="text-info cursor-pointer mr-1"></i>
          </a>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="datatable-footer-inner">
          <div class="page-count">
            Toplam Veri {{ totalCount }}
          </div>
          <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
            (pageChange)="onPageChange($event)">
            <ng-template ngbPaginationPrevious>
              <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
            </ng-template>
            <ng-template ngbPaginationNext>
              <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
            </ng-template>
          </ngb-pagination>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>

  <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="create-project"
    overlayClass="modal-backdrop">
    <app-project-create [data]="projectId"></app-project-create>
  </core-sidebar>
</div>